import React, { useState } from "react"
import { ModalPanel, Title, Button, SingleLineTextInput } from "dash-styled"
import { CollaboratorRole } from "../../../../../Models/API/CollaboratorModel"
import { useAsyncCommand } from "../../../../../Hooks/useAsyncCommand"
import { CollaboratorRoleChooser } from "./CollaboratorRoleChooser"

interface Props {
    email: string
    currentRole: CollaboratorRole
    onSubmit?: (role: CollaboratorRole) => Promise<void>
    onViewPermissions: () => void
    toggleModal: () => void
}

export const CollaboratorRoleModal: React.FC<Props> = ({
    email,
    currentRole,
    onSubmit,
    toggleModal,
    onViewPermissions
}: Props) => {
    const [role, setRole] = useState<CollaboratorRole>(currentRole)
    const handleToggleModal = () => toggleModal()
    const { perform, isProcessing } = useAsyncCommand(
        onSubmit === undefined ? undefined : () => onSubmit(role)
    )

    return (
        <ModalPanel onClose={handleToggleModal} className="w-full max-w-3xl">
            <Title variant="heading2" weight="semibold">
                Change role
            </Title>
            <div className="mx-4 py-4">
                <SingleLineTextInput
                    label="Email"
                    value={email}
                    disabled={true}
                    className="mb-1"
                />
                <CollaboratorRoleChooser
                    label="New role"
                    className="mb-8"
                    value={role}
                    onChange={setRole}
                    onViewPermissions={onViewPermissions}
                />
            </div>
            <div className="flex justify-center">
                <Button
                    color="plain"
                    onClick={handleToggleModal}
                    className="w-48 mr-4"
                >
                    Cancel
                </Button>
                <Button
                    onClick={perform}
                    className="w-48"
                    disabled={isProcessing || currentRole === role}
                >
                    {isProcessing ? "Updating..." : "Update"}
                </Button>
            </div>
        </ModalPanel>
    )
}
